import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

export const Select2Data = async (data, name, other = false) => {
  const result = data.map((data) => ({
    value: data?.id,
    label: data?.name,
    name: name,
  }));

  if (other) {
    result.push({ value: "0", label: "Other", name: name });
  }
  return result;
};

export const Select2DataCustomerId = async (data, name, other = false) => {
  const result = data.map((data) => ({
    value: data?.id,
    label: data?.unique_id,
    name: name,
    customer_name: data?.name,
  }));

  if (other) {
    result.push({ value: "0", label: "Other", name: name });
  }
  return result;
};

export const Select3Data = (data, name, other = false) => {
  const result = data.map((item) => ({
    value: item.id,
    label: item.instrument_name,
    name: name,
    data: item,
  }));

  if (other) {
    result.push({
      value: "0",
      label: "Other",
      name: name,
    });
  }

  return result;
};

export const Select4Data = (data, name, other = false) => {
  const result = data.map((item) => ({
    value: item.id,
    label: item.unique_id,
    name: name,
    data: item,
  }));

  if (other) {
    result.push({
      value: "0",
      label: "Other",
      name: name,
    });
  }

  return result;
};

export const handleDecimalKeyDown = (e) => {
  const allowedKeys = [
    "Backspace",
    "Tab",
    "ArrowLeft",
    "ArrowRight",
    "Delete",
    ".",
    "Home",
    "End",
  ];
  const isNumber = /^[0-9]$/.test(e.key);

  if (!isNumber && !allowedKeys.includes(e.key)) {
    e.preventDefault();
  }

  // Prevent multiple dots
  if (e.key === "." && e.currentTarget.value.includes(".")) {
    e.preventDefault();
  }
};

export const formatDate = (dateString) => {
  // if (!dateString) return '';
  // const date = new Date(dateString);
  // return `${date.toISOString().slice(0, 10)}`; // returns 'YYYY-MM-DD'
  if (!dateString) return "";
  const date = new Date(dateString);
  // Format: DD-MM-YYYY
  const formattedDate = `${String(date.getDate()).padStart(2, "0")}-${String(
    date.getMonth() + 1,
  ).padStart(2, "0")}-${date.getFullYear()}`;
  return formattedDate;
};


export const formatDateForInput = (date) => {
  if (!date) return "";
  return new Date(date).toISOString().split("T")[0];
};

export const Last_Login = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  const options = {
    hour: "2-digit",
    minute: "2-digit",
    // second: '2-digit',
    hour12: true, // Set to true for AM/PM format
  };
  const time = date.toLocaleTimeString("en-US", options);
  return `${time} on ${date.toISOString().slice(0, 10)}`; // returns 'YYYY-MM-DD'
};

export const ProtectedRoute = ({ permissionId, children }) => {
  const permissions = useSelector((state) => state.auth.permissions);

  if (!permissions) {
    return <div>Loading...</div>;
  }

  const hasPermission = permissions.some(
    (p) => Number(p) === Number(permissionId) || p?.id === permissionId,
  );

  if (!hasPermission) {
    return <Navigate to="/no-access" replace />;
  }

  return children;
};
